import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import { Button, ButtonProps } from "src/components/base/button";
import { GTM_COPY_ISIN_BUTTON } from "src/consts/gtm";
import { useCopyIsin } from "src/hooks/use-copy-isin";

interface ICopyIsinButtonProps extends ButtonProps {
    isin: string;
    children?: ReactNode;
}

export const CopyIsinButton = ({ isin, onClick, children, ...buttonProps }: ICopyIsinButtonProps) => {
    const { t } = useTranslation("common");
    const { copyIsin } = useCopyIsin({ isin, onCopySuccess: onClick });

    return (
        <Button onClick={copyIsin} {...buttonProps} className={GTM_COPY_ISIN_BUTTON} data-isin={isin}>
            {children || t("copy-isin")}
        </Button>
    );
};
